import { KLIKOO_CASHIER } from "../../constants/kasir/constant";

const initialState = {
  // Token
  loadingGetKlikooToken: false,
  dataGetKlikooToken: null,

  // Product
  loadingGetKlikooProduct: false,
  dataGetKlikooProduct: null,

  // Inquiry Prepaid
  loadingInquiryPrepaid: false,
  dataInquiryPrepaid: null,

  // Inquiry Postpaid
  loadingInquiryPostpaid: false,
  dataInquiryPostpaid: null,

  // Buy Product
  loadingBuyProduct: false,
  dataBuyProduct: null,

  // Lookup Member
  loadingLookupMember: false,
  dataLookupMember: null,

  // Payment
  loadingPayment: false,
  dataPayment: null,
};

const klikooCashierReducer = (state = initialState, action) => {
  switch (action.type) {
    // Token
    case KLIKOO_CASHIER.LOADING_GET_KLIKOO_TOKEN:
      return { ...state, loadingGetKlikooToken: action.load };
    case KLIKOO_CASHIER.GET_KLIKOO_TOKEN:
      return { ...state, dataGetKlikooToken: action.data };

    // Product
    case KLIKOO_CASHIER.LOADING_GET_KLIKOO_PRODUCT:
      return { ...state, loadingGetKlikooProduct: action.load };
    case KLIKOO_CASHIER.GET_KLIKOO_PRODUCT:
      return { ...state, dataGetKlikooProduct: action.data };

    // Inquiry Prepaid
    case KLIKOO_CASHIER.LOADING_INQUIRY_PREPAID:
      return { ...state, loadingInquiryPrepaid: action.load };
    case KLIKOO_CASHIER.INQUIRY_PREPAID:
      return { ...state, dataInquiryPrepaid: action.data };

    // Inquiry Postpaid
    case KLIKOO_CASHIER.LOADING_INQUIRY_POSTPAID:
      return { ...state, loadingInquiryPostpaid: action.load };
    case KLIKOO_CASHIER.INQUIRY_POSTPAID:
      return { ...state, dataInquiryPostpaid: action.data };

    // Buy Product
    case KLIKOO_CASHIER.LOADING_BUY_PRODUCT:
      return { ...state, loadingBuyProduct: action.load };
    case KLIKOO_CASHIER.BUY_PRODUCT:
      return { ...state, dataBuyProduct: action.data };

    // Lookup Member
    case KLIKOO_CASHIER.LOADING_LOOKUP_MEMBER:
      return {
        ...state,
        loadingLookupMember: action.load,
      };
    case KLIKOO_CASHIER.LOOKUP_MEMBER:
      return {
        ...state,
        dataLookupMember: action.data,
      };

    // Payment
    case KLIKOO_CASHIER.LOADING_PAYMENT:
      return {
        ...state,
        loadingPayment: action.load,
      };
    case KLIKOO_CASHIER.PAYMENT:
      return {
        ...state,
        dataPayment: action.data,
      };

    default:
      return state;
  }
};

export default klikooCashierReducer;
